// notifications.js 			                             ~/js/
////////////////////////////////////////////////////////////

const banner = document.querySelector('.banner-block');
const mobileMenu = document.querySelector('.menu-mobile');

if (document.body.contains(banner)) {
  mobileMenu.classList.add('banner-active');
} else {
  mobileMenu.classList.remove('banner-active');
}
